export const FUND_SUMMARY_SPREADSHEET_HEADER_TITLE = 'FUND_SUMMARY_SPREADSHEET_HEADER_TITLE';
export const FUND_SUMMARY_SPREADSHEET_TOTAL = 'FUND_SUMMARY_SPREADSHEET_TOTAL';
